<generic-search-results
    [showHeader]="false"
    [showCounter]="false"
    [title]="''"
    [records]="appsUsed"
    [displayedColumns]="displayColumns"
    [selectableRecords]="false"
    [allowLocalFilter]="false"
></generic-search-results>